import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.DEFAULT,
    alt: 'college dorm moving page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'college dorm moving page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Secure <span>College Dorm</span><span>Moving Services</span>',
  description:
    'Move into your college dorm easily and affordably with our seamless service, ensuring fast delivery, secure handling, and flexible options nationwide.',
  image: {
    url: '/images/v2/pages/landing-pages/college-dorm-moving/hero-image.jpg',
    alt: 'Secure College Dorm Moving Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up for Dorm Moving' }
}

export const ourProcessSectionContent = {
  title: 'How We Help College Dorm Moving Services Fast',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/college-dorm-moving/how-we-help-college-dorm-moving-services-fast.png',
    alt: 'How We Help College Dorm Moving Services Fast'
  },

  articles: [
    {
      id: 1,
      title: 'Simple Scheduling',
      description:
        'Choose your desired pickup date online, and our team will arrive at your doorstep to collect your dorm items without hassle.',
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/simple-scheduling.png',
        alt: 'Simple Scheduling'
      }
    },
    {
      id: 2,
      title: 'Secure Storage',
      description:
        'We offer secure and organized storage options to keep your belongings safe until they are ready to be shipped to your dorm.',
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/secure-storage.png',
        alt: 'Secure Storage'
      }
    },
    {
      id: 3,
      title: 'Hassle-Free Delivery',
      description:
        'Enjoy timely delivery to any dorm or residence across the country with our reliable logistics network.',
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/hassle-free-delivery.png',
        alt: 'Hassle-Free Delivery'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Reliable Dorm Moving Storage Solutions',
  description:
    'With ShipAndStorage, you can trust us to move your dorm items safely, on time, and affordably. We specialize in college dorm moving, providing solutions tailored to the unique needs of students and their families.',
  image: {
    src: '/images/v2/pages/landing-pages/college-dorm-moving/reliable-dorm-moving-storage-solutions.jpg',
    alt: 'Reliable Dorm Moving Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using College Dorm Moving Services',

  cards: [
    {
      id: 1,
      title: 'Cost-Effective Options',
      description:
        'Our pricing plans are designed to fit every budget, offering students affordable and flexible dorm moving solutions.',
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/cost-effective-options.png',
        alt: 'Cost-Effective Options'
      }
    },
    {
      id: 2,
      title: 'Stress-Free Process',
      description:
        'From packing and storage to delivery, we manage every detail, ensuring a smooth moving experience for students and parents.',
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/stress-free-process.png',
        alt: 'Stress-Free Process'
      }
    },
    {
      id: 3,
      title: 'Nationwide Coverage',
      description:
        'We serve colleges, dorms, and residences across the U.S., making our services accessible no matter where your dorm is located.',
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/nationwide-coverage.png',
        alt: 'Nationwide Coverage'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose ShipAndStorage for College Dorm Moving Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'New College Students',
          description:
            "Whether you're moving into your first dorm or returning to campus, we make your move easy and stress-free."
        },
        {
          id: 2,
          title: 'Parents Assisting Students',
          description:
            'Parents can rely on us for convenient, secure, and affordable moving options for their college-bound children.'
        },
        {
          id: 3,
          title: 'International Students',
          description:
            'From global shipping to local solutions, we simplify the process for international students relocating to the U.S.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/who-should-choose-shipandstorage-for-college-dorm-moving-services.jpg',
        alt: 'Who Should Choose ShipAndStorage for College Dorm Moving Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solutions',
      description:
        'Keep your office organized with affordable and secure storage for inventory, documents, or equipment.',
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description: 'Moving to a new home? Enjoy stress-free storage solutions during your transition.',
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Ship your luggage or boxes locally and internationally with ease and affordability.',
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description: 'Ideal for homeowners during renovations, moves, or extended vacations.',
      image: {
        src: '/images/v2/pages/landing-pages/college-dorm-moving/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for College Dorm Moving Services',

  image: {
    url: '/images/v2/pages/landing-pages/college-dorm-moving/why-choose-shipandstorage-for-college-dorm-moving-services.jpg',
    alt: 'Why Choose ShipAndStorage for College Dorm Moving Services'
  },

  articles: [
    {
      id: 1,
      title: 'Comprehensive Convenience',
      description: 'We manage every aspect of college dorm moving, from pickup to delivery, so you don’t have to worry.'
    },
    {
      id: 2,
      title: 'Flexible Storage Options',
      description:
        'Choose from various storage plans that fit your needs, whether you have one small box or several large items.'
    },
    {
      id: 3,
      title: 'Transparent Pricing',
      description:
        'Enjoy competitive rates with no hidden fees. Our pricing plans are clear and designed for student budgets.'
    },
    {
      id: 4,
      title: 'Fast and Reliable Delivery',
      description: 'Our efficient logistics guarantee that your dorm items arrive on time, every time, without delays.'
    },
    {
      id: 5,
      title: 'Secure Handling',
      description:
        'Your belongings are stored and shipped with care, ensuring safety and reliability throughout the process.'
    },
    {
      id: 6,
      title: 'Student-Centered Solutions',
      description:
        'We focus on the unique needs of students, providing services that simplify life for them and their families.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Fast and Secure College Dorm Moving Solutions',
  description:
    'Fast, secure college dorm moving services for students. Affordable solutions for moving your belongings safely to your dorm room.',
  image: {
    src: '/images/v2/pages/landing-pages/college-dorm-moving/fast-and-secure-college-dorm-moving-solutions.png',
    alt: 'Fast and Secure College Dorm Moving Solutions'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Your Dorm Move' }
}

export const ourPartnersSectionContent = {
  title: 'Our Shipping Partners',
  description:
    'ShipAndStorage collaborates with leading global carriers such as FedEx, DHL, and UPS to provide top-notch shipping and storage solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'Established in 1971 by Frederick W. Smith, FedEx started with just 186 packages and has evolved into a global shipping powerhouse. Today, FedEx boasts a fleet of 696 aircraft and 215,000 vehicles, handling 16 million shipments daily across over 220 countries and territories. With a workforce exceeding 550,000 and more than 5,000 locations worldwide, FedEx ensures reliable and timely deliveries.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL Express, a key division of Deutsche Post DHL Group, is well-known for its international courier, parcel, and express mail services. As a leader in logistics, DHL manages over 1.8 billion parcels each year. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became a wholly-owned subsidiary of Deutsche Post in 2002 and operates in more than 220 countries, playing a crucial role in the global supply chain.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'Founded as the American Messenger Company in Seattle in 1907 by teenagers Claude Ryan and Jim Casey, UPS rebranded to United Parcel Service (UPS) in 1919. Today, UPS ranks among the largest shipping companies worldwide, delivering 25 million packages each day. With over 500,000 employees globally, UPS serves more than 220 countries and territories, offering unparalleled global reach.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
